import React, { useCallback, useEffect, useState } from 'react'
import TitileAndArrowBack from '../../components/TitileAndArrowBack/TitileAndArrowBack'
import { Link, useNavigate } from "react-router-dom";
import HelmetComponent from '../../components/Helmet/Helmet';
import { CustomCheckbox } from './CustomCheckBox';
import FormatPrice from '../../components/FormatPrice/FormatPricw'; /* seprates each 3 digists by ,  */
import ConvertPersianToEnglish from '../../components/ConvertToEnglish/ConvertToEnglish';
import Num2persian from 'num2persian';
import { useLocations } from '../../States/Location/Location';
import { Spin } from 'antd';
import { NewAllCoordinates } from '../AdsOnMap/NewAllCoordinates';
import CreateFileMap from './CreateFileMap';
import { useAdvertise } from '../RegisterAD/connectApi/registers';


const CreateFile = () => {
    const navigate = useNavigate();

    const allCoordinates = NewAllCoordinates;
    const { getAllProvinses, getAllCities, getAllNeighbourhood } = useLocations((state) => state.actions);
    const { saveOrderImg, postAllAdvertise, postEditAdsDetail, postEditAdsPrptyApplicantRentBuy, addPhoneNumber } = useAdvertise((state) => state.actions);
    const provinses = useLocations((state) => state.provinses);
    const cities = useLocations((state) => state.cities);
    const neighbourhood = useLocations((state) => state.neighbourhood);
    const districtsLoader = useLocations((state) => state.districtsLoader);






    const [selectedMainImages, setSelectedMainImages] = useState([]);
    const [adsPrptyCategoryCode, setAdsPrptyCategoryCode] = useState(null)
    const [slideTransaction, setslideTransaction] = useState(false);
    const [numberofTransaction, setnumberofTransaction] = useState(0);
    const [slidecate, setslidecate] = useState(false);
    const [provinceClicked, setProvinceClicked] = useState(false);
    const [cityClicked, setCityClicked] = useState(false);
    const [districtClicked, setDistrictClicked] = useState(false);

    const [slideHome, setslideHome] = useState(false);
    const [numberofhome, setnumberofhome] = useState(0);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedAdsMainCategoryCode, setSelectedAdsMainCategoryCode] =
        useState(null);
    const [selectedCountryCode, setSelectedCountryCode] = useState(1);
    const [selectedStateCode, setSelectedStateCode] = useState(2);
    const [selectedCityCode, setselectedCityCode] = useState(3);
    const [pricePerMeter, setpPricePerMeter] = useState();
    const [totalPrice, setTotalPrice] = useState();
    const [rent, setRent] = useState();
    const [deposite, setDeposite] = useState();
    const [selectedAreaCode, setselectedAreaCode] = useState(null);
    const [selectedLatitude, setselectedLatitude] = useState(null);
    const [locationAlert, setLocationAlert] = useState(false)
    const [selectedLongitude, setselectedLongitude] = useState(null);
    const [selectedAdsTitle, setselectedAdsTitle] = useState("");
    const [selectedMobilePhone, setselectedMobilePhone] = useState("");
    const [selectedLandPhone, setselectedLandPhone] = useState("");
    const [selectedPrice, setselectedPrice] = useState("");
    const [selectedDescription, setselectedDescription] = useState("");
    const [isInputEmptyTitle, setIsInputEmptyTitle] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState("ایران");
    const [selectedProvinses, setselectedProvinses] = useState("تهران");
    const [selectedcitiess, setSelectedcitiess] = useState("تهران");
    const [isShowCityMenu, setisShowCityMenu] = useState(false);
    const [isShowNeighbourhoodMenu, setisShowNeighbourhoodMenu] = useState(false);
    const [isShowProvincMenu, setisShowProvincMenu] = useState(false);
    const [isShowCountryMenu, setisShowCountryMenu] = useState(false);
    const [selectRadioCountry, setselectRadioCountry] = useState(false);
    const [selectRadioProvice, setselectRadioProvice] = useState(false);
    const [selectRadioCity, setselectRadioCity] = useState(false);
    const [selectedneighbourhood, setSelectedneighbourhood] = useState(null);
    const [valueDate, setValueDate] = useState();
    const [valueTimeFrom, setValueTimeFrom] = useState(null);
    const [valueTimeTo, setValueTimeTo] = useState(null);
    const [choosePropertyType, setChoosePropertyType] = useState(false);
    const [isChooseLocationSectionOpen, setIsChooseLocationSectionOpen] = useState(false);
    const [isFacilitiesSectionOpen, setIsFacilitiesSectionOpen] = useState(false);
    const [formPageVisible, setFormPageVisible] = useState(false);
    const [hasNotChanged, setHasNotChanged] = useState(false);
    const [abilityToConvert, setAbilityToConvert] = useState(false);
    const [convertingDeposite, setConvertingDeposite] = useState();
    const [convertingRent, setConvertingRent] = useState();
    const [unitPerFloor, setUnitPerFloor] = useState(null);
    const [floorFrom, setFloorFrom] = useState(null);
    const [floorTo, setFloorTo] = useState(null);
    const [lifeOfTheBuilding, setLifeOfTheBuilding] = useState(null);
    const [numberOfRooms, setNumberOfRooms] = useState(null);
    const [meterage, setMeterage] = useState(null);
    const [propertyLandMetarage, setPropertyLandMetarage] = useState(null);
    const [propertyWidth, setPropertyWidth] = useState(null);
    const [meterageFrom, setMeterageFrom] = useState(null);
    const [meterageTo, setMeterageTo] = useState(null);
    const [totalPriceFrom, setTotalPriceFrom] = useState(null);
    const [totalPriceTo, setTotalPriceTo] = useState(null);
    const [depositeFrom, setDepositeFrom] = useState(null);
    const [depositeTo, setDepositeTo] = useState(null);
    const [rentFrom, setRentFrom] = useState(null);
    const [rentTo, setRentTo] = useState(null);
    const [lifeOftheBuildingFrom, setLifeOftheBuildingFrom] = useState(null);
    const [lifeOftheBuildingTo, setLifeOftheBuildingTo] = useState(null);


    const [selectedProvince, setSelectedProvince] = useState({
        id: 2,
        locName: "تهران",
        locParentId: 1
    });
    const [selectedCity, setSelectedcity] = useState({
        id: 3,
        locName: "تهران",
        locParentId: 2
    });
    const [selectedDistrict, setSelectedDistrict] = useState({
        id: 3,
        locName: "",
        locParentId: 3
    });
    const [markerPosition, setMarkerPosition] = useState([])
    const [description, setDescription] = useState("")
    const [selectedpossibilityInPhoneVisit, setselectedpossibilityInPhoneVisit] =
        useState(true);

    const [
        selectedpossibilityInPersonVisit,
        setselectedpossibilityInPersonVisit,
    ] = useState(false);
    const maxVideos = 3; // Define the maximum number of videos
    const [selectedpossibilityComment, setselectedpossibilityComment] =
        useState(false);
    const handleselectedpossibilityComment = () => {
        setselectedpossibilityComment(!selectedpossibilityComment);
    };
    const [images, setImages] = useState([
        // 'https://via.placeholder.com/300',
    ]);
    const [imageList, setImageList] = useState([]);
    const [dangerSliderImg, setdangerSliderImg] = useState(false);
    const [dangerSliderVd, setdangerSliderVd] = useState(false);
    const [dangerSliderMaxVd, setdangerSliderMaxVd] = useState(false);
    const [dangerSliderSizeVd, setdangerSliderSizeVd] = useState(false);
    const [dangerSliderFormat, setdangerSliderFormat] = useState(false);
    const [dangerSliderTwoShow, setdangerSliderTwoShow] = useState(false);
    const [numberOfVideo, setNumberOfVideo] = useState(0);
    const [selectedTypeShowchecked, setSelectedTypeShowchecked] = useState(false);
    const [selectedTypeShow, setSelectedTypeShow] = useState(1);
    const [sales, setSales] = useState(false);
    const [showvalueDate, setshowvalueDate] = useState("");
    const [state, setState] = useState({ format: "MM-DD-YYYY" });
    const [selectedAddress, setselectedAddress] = useState("");
    const [selectedSubTitleTypeAD, setselectedSubTitleTypeAD] = useState("");
    const [HarrajiOrNo, setHarrajiOrNo] = useState(1);
    const [adsPrptyTradeTypeCode, setAdsPrptyTradeTypeCode] = useState(null)
    const [adsPrptyTypeCode, setAdsPrptyTypeCode] = useState(null)
    const [hasElevator, setHasElevator] = useState(true);
    const [hasBasement, setHasBasement] = useState(false);
    const [hasParking, setHasParking] = useState(false);
    const [fulName, setFulName] = useState("");
    const [inputPhone, setInputPhone] = useState("");
    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [polygonForMap, setPolygonForMap] = useState([]);
    const [fileTitle, setFileTitle] = useState("");
    const [fileAddress, setFileAddress] = useState("");
    const [squareFootageEntireProperty, setSquareFootageEntireProperty] = useState(null);
    const [oneSided, setOneSided] = useState(false);
    const [mutualAgreement, setMutualAgreement] = useState(false);
    const [equalSplit, setEqualSplit] = useState(false);
    const [notEqualSplit, setNotEqualSplit] = useState(false);
    const slidetransaction = (index) => {


        setSelectedIndex(index);
        setslideTransaction(true);
        setnumberofTransaction(index + 1);
        setChoosePropertyType(true)
    };
    console.log(adsPrptyTradeTypeCode, "adsPrptyTradeTypeCode createFile");
    console.log(adsPrptyTypeCode, "adsPrptyTypeCode createFile");

    const reset = () => {
        // reset value of select location modal
        // country
        setSelectedCountryCode(1);
        setSelectedCountry(null);
        setisShowCountryMenu(false);
        setselectRadioCountry(false);
        // Provinse
        setselectedProvinses(null);
        setSelectedStateCode(2);
        setisShowProvincMenu(false);
        setselectRadioProvice(false);
        // city
        setSelectedcitiess(null);
        setselectedCityCode(3);
        setisShowCityMenu(false);
        setselectRadioCity(false);
        // neighbourhood
        setSelectedneighbourhood(null);
        setselectedAreaCode(null);
        setisShowNeighbourhoodMenu(false);
        // reset value of select location modal

        // reset value of ADsName
        setselectedAdsTitle("");
        setIsInputEmptyTitle(false);
        // reset value of ADsName

        // reset value in imgModal
        // slider
        setImages([]);
        setImageList([]);
        // TwoCard
        setSelectedTypeShowchecked(false);
        setSelectedTypeShow(1);
        // Auction
        setSales(false);
        setselectedpossibilityInPersonVisit(false);
        setshowvalueDate("");
        setState({ format: "MM-DD-YYYY" });
        setValueTimeFrom(null);
        setValueTimeTo(null);
        setselectedAddress("");
        setselectedSubTitleTypeAD("");
        setHarrajiOrNo(1);


        setselectedLandPhone("");


        setselectedpossibilityComment(false);
    };

    // const goback = () => {


    //     if (selectedIndex == 3) {
    //         navigate("/");
    //         setslideHome(false);
    //         setnumberofTransaction(0);
    //     }
    //     reset();
    //     if (!slidecate && !slideTransaction && !slideHome) {
    //         navigate(-1);
    //     }
    //     if (slidecate && !slideTransaction && !slideHome) {

    //         setslidecate(false);
    //     }

    //     if (slidecate && slideTransaction && !slideHome) {
    //         setslideTransaction(false);
    //     }
    //     if (slidecate && slideTransaction && slideHome) {

    //         setslideHome(false);
    //     }
    //     if (!slidecate && slideTransaction && !slideHome) {

    //         setslideTransaction(false);
    //     }
    //     if (!slidecate && slideTransaction && slideHome) {
    //         setslideHome(false);
    //     }

    // };
    const handleMarkerChange = useCallback((position) => {
        console.log("Marker moved to:", position);
        setMarkerPosition([position?.lat, position?.lng]);
    }, []);

    const handleSubmit = async () => {
        try {
            const response = await postAllAdvertise({
                id: 0,
                UsruserCode: localStorage.getItem("pelakAuthData"),
                AdsMainCategoryCode: 1,
                adsAdvertiseShowTypeCode: 1,
                countryCode: 1,
                StateCode: selectedProvince?.id,
                CityCode: selectedCity?.id,
                AreaCode: selectedDistrict?.id,
                Latitude: markerPosition[0],
                Longitude: markerPosition[1],
                isApproximateArea: false,
                AdsTitle: fileTitle,
                address: fileAddress,
                ownerName: "",
                MobilePhone: phoneNumbers[0],
                LandPhone: phoneNumbers[0],
                Price: totalPrice,
                Description: description,
                isBlockCommnet: false,
                isActiveChat: false,
                isShowMobile: true,
            });
            await postEditAdsDetail(

                    /* "id" */0,
                    /* "adsMasterCode"*/Number(localStorage.getItem("idMaster")),
                    /* "adsPrptyCategoryCode"*/adsPrptyCategoryCode,
                    /* "adsPrptyTradeTypeCode"*/adsPrptyTradeTypeCode,
                    /* "adsPrptyTypeCode"*/adsPrptyTypeCode,
                    /* "adsAdvertiseTypeCode"*/1,
                    /* "pricePerMeter"*/pricePerMeter,
                    /* "totalPrice"*/totalPrice,
                    /* "propertyLandMetarage"*/propertyLandMetarage,
                    /*  "propertyWidth"*/propertyWidth,
                    /* "deposit"*/deposite,
                    /* "squareFootageEntireProperty"*/squareFootageEntireProperty,
                    /* "rentPerMonth"*/rent,
                    /*  "abilityToConvert"*/abilityToConvert,
                    /*  "convertingDepositAmount"*/convertingDeposite,
                    /* "convertingRentAmount"*/convertingRent,
                    /* "meterage"*/meterage,
                    /* "numberOfRooms"*/numberOfRooms,
                    /* "lifeOfTheBuilding"*/lifeOfTheBuilding,
                    /* "dateForRent"*/null,
                    /* "floorNumber"*/floorFrom,
                    /* "totalFloor"*/floorTo,
                    /* "unitPerFloor"*/unitPerFloor,
                    /* "parking"*/hasParking,
                    /* "basement"*/hasBasement,
                    /*  "elevator"*/hasElevator,
                    /* "description",*/description,

            )
            // moteqazie kharid va ejare
            if (adsPrptyCategoryCode === 10 || adsPrptyCategoryCode === 11) {
                await postEditAdsPrptyApplicantRentBuy(

                    /* "adsMasterCode" */Number(localStorage.getItem("idMaster")),
                    /* "adsPrptyTradeTypeCode" */adsPrptyTradeTypeCode,
                    /* "adsPrptyTypeCode"*/adsPrptyTypeCode,
                    /* "applicantType"*/ adsPrptyCategoryCode === 10 ? 1 : 2,
                    /* "buyPriceFrom"*/totalPriceFrom,
                    /* "buyPriceTo"*/totalPriceTo,
                    /* "rentDepositFrom"*/depositeFrom,
                    /* "rentDeposintTo"*/depositeTo,
                    /* "rentPriceFrom"*/rentFrom,
                    /* "rentPriceTo"*/rentTo,
                    /* "metrageFrom"*/meterageFrom,
                    /* "meterageTo"*/meterageTo,
                    /* "lifeOfBuildingFrom"*/lifeOftheBuildingFrom,
                    /* "lifeOfBulidingTo"*/lifeOftheBuildingTo,
                    /*"description"*/description,

                )
            }
            await addPhoneNumber(localStorage.getItem("idMaster"), phoneNumbers)
            console.log("Advertise posted:", response);

            for await (const image of imageList) {
                await saveOrderImg(
                    Number(localStorage.getItem("idMaster")),
                    image.file,
                    image.priority
                );
                console.log("Image saved:", image);
            }

        } catch (error) {
            console.error("Submit failed:", error);
        }
    };
    const goBack = () => {
        setAdsPrptyCategoryCode(null)

        if (formPageVisible) {
            setFormPageVisible(false);
            return;
        }

        if (choosePropertyType) {
            // If we're on the third slide, go back to the second
            setChoosePropertyType(false);
            return;
        }
        if (slidecate) {
            // If we're on the first slide, go back or reset
            setslidecate(false);
            return;
        }
        if (slideTransaction) {
            // If we're on the second slide, go back to the first
            setslideTransaction(false);
            return;
        }


        // If none are active, go back normally or to home
        reset();
        navigate(-1);

    };
    const slideCateHandler = (index) => {
        setslidecate(true);
        if (index === 0) {
            setSelectedAdsMainCategoryCode(1);
        } else if (index === 3) {
            // taavon
            setSelectedAdsMainCategoryCode(8);
        }
    };
    console.log(selectedAdsMainCategoryCode, "selectedAdsMainCategoryCode selectedAdsMainCategoryCode");


    const slideregister = (index) => {
        setnumberofhome(index + 1);
        setslideHome(true);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        console.warn("SELECTED file");


        if (file) {
            const reader = new FileReader(); // Create a single FileReader object

            if (file.type.startsWith("video/") && file.size > 200 * 1024 * 1024) {
                setdangerSliderVd(true);
                return;
            } else {
                setdangerSliderVd(false);
            }

            if (
                file.type.startsWith("image/") &&
                (file.name.endsWith(".jpg") ||
                    file.name.endsWith(".jpeg") ||
                    file.name.endsWith(".png") ||
                    file.name.endsWith(".webp") ||
                    file.name.endsWith(".heic") ||
                    file.name.endsWith(".heif")
                )
            ) {
                // setdangerSliderFormatImg(false);
                setdangerSliderFormat(false);
            } else if (file.type.startsWith("video/") && (file.name.endsWith(".mov")
                || file.name.endsWith(".MOV") || file.name.endsWith(".mp4") ||
                file.name.endsWith(".m3u8") || file.name.endsWith(".ts") ||
                file.name.endsWith(".3gp") || file.name.endsWith(".mov"))) {
                setdangerSliderFormat(false);
            } else {
                // setdangerSliderFormatImg(true);
                setdangerSliderFormat(true);
                alert(file.name)
                return;
            }

            if (file.type.startsWith("image/") && file.size > 5 * 1024 * 1024) {
                setdangerSliderImg(true);
                return;
            } else {
                setdangerSliderImg(false);
            }

            if (
                file.type.startsWith("video/") &&
                imageList.filter((item) => item.file.type.startsWith("video/"))
                    .length >= maxVideos
            ) {
                setdangerSliderMaxVd(true);
                return;
            } else {
                setdangerSliderMaxVd(false);
            }

            if (file.type.startsWith("image/")) {
                const image = new Image();
                image.onload = () => {
                    if (image.width < 20 || image.height < 36) {
                        setdangerSliderSizeVd(true);
                    } else {
                        setdangerSliderSizeVd(false);
                        reader.readAsDataURL(file); // Read the image file once it's loaded
                    }
                };
                image.src = URL.createObjectURL(file);
            } else if (file.type.startsWith("video/")) {
                // Handling video files
                setImages([...images, URL.createObjectURL(file)]); // Add video URL to images
                setImageList([
                    ...imageList,
                    {
                        fileName: reader.result,
                        tblAdsMasterCode: Number(localStorage.getItem("idMaster")),
                        file,
                        priority:
                            images.filter((item) => item.startsWith("data:image/")).length +
                            1,
                    },
                ]); // Add video file to imageList
                setNumberOfVideo(numberOfVideo + 1);

            }

            reader.onloadend = () => {
                setImages([...images, reader.result]);
                setImageList([
                    ...imageList,
                    {
                        fileName: reader.result,
                        tblAdsMasterCode: Number(localStorage.getItem("idMaster")),
                        file,
                        priority:
                            images.filter((item) => item.startsWith("data:image/")).length +
                            1,
                    },
                ]);
            };


            setSelectedMainImages([0]);
            // setSelectedMainImages([imageList.length - 1]);

        }
    };
    const handleDelete = (index) => {
        const updatedImages = [...images];
        const updatedImageList = [...imageList];

        const isVideo = updatedImages[index]?.startsWith("data:video/");
        if (isVideo) setNumberOfVideo(prev => prev - 1);

        updatedImages.splice(index, 1);
        updatedImageList.splice(index, 1);

        setImages(updatedImages);
        setImageList(updatedImageList);

        // Adjust main image index
        if (selectedMainImages[0] === index) {
            setSelectedMainImages([0]); // fallback to first
        } else if (selectedMainImages[0] > index) {
            setSelectedMainImages([selectedMainImages[0] - 1]);
        }
    };

    const home = [
        { id: 1, title: "آپارتمان مسکونی", href: "" },
        { id: 2, title: "آپارتمان اداری", href: "" },
        { id: 3, title: "خانه و ویلا", href: "" },
        { id: 4, title: "زمین و کلنگی", href: "" },
        { id: 5, title: "مستغلات", href: "" },
        { id: 6, title: "مغازه", href: "" },
        { id: 7, title: "صنعتی و کشاورزی", href: "" },
    ];

    const transaction = [
        { id: 1, title: "فروش", href: "" },
        { id: 2, title: "رهن و اجاره", href: "" },
        { id: 3, title: "معاوضه", href: "" },
        { id: 4, title: "مشارکت در ساخت", href: "" },
        { id: 5, title: "پیش فروش", href: "" },
        { id: 6, title: "رهن و اجاره کوتاه مدت", href: "" },
        // { id: 7, title: "متقاضی خرید", href: "" },
        // { id: 8, title: "متقاضی اجاره", href: "" },
    ];
    const categoryMap = {
        1: { 1: 1, 2: 2, 3: 1, 4: 8, 5: 1, 6: 9, 7: 10, 8: 11 }, // adsPrprtyType: 1
        2: { 1: 1, 2: 2, 3: 1, 4: 8, 5: 1, 6: 1, 7: 10, 8: 11 }, // adsPrprtyType: 2
        3: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: 9, 7: 10, 8: 11 },
        4: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: null, 7: 10, 8: 11 },
        5: { 1: 6, 2: 7, 3: 6, 4: 8, 5: 6, 6: null, 7: 10, 8: 11 },
        6: { 1: 3, 2: 4, 3: 3, 4: 8, 5: 3, 6: null, 7: 10, 8: 11 },
        7: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: 9, 7: 10, 8: 11 },
        // Add other adsPrprtyType and adsPrprtyTradeType mappings here
    };
    function getAdsPrprtyCategory(adsPrprtyType, adsPrprtyTradeType) {
        return categoryMap[adsPrprtyType]?.[adsPrprtyTradeType] ?? null; // Default to null if not found
    }
    const files = [
        {
            // imgSrc: "/icons/pelake-man-register-home.svg",
            imgSrc: localStorage.getItem("veeu-dark-mode") ? "/icons/dark-register-home.svg" : "/icons/pelake-man-register-home.svg",
            title: "ثبت فایل در پلاک من (ویژه مالکین)",
            desc: "آرامـش خـود را با ثبت فایل در پلاک مـن به دست آورید.",
            id: 1,
        },
        {
            // imgSrc: "/icons/pelake-man-register-hands.svg",
            imgSrc: localStorage.getItem("veeu-dark-mode") ? "/icons/dark-register-group.svg" : "/icons/pelake-man-register-hands.svg",
            title: "متقاضی خرید (ویژه خریداران)",
            desc: "قدمـی ارزنده به سوی داشتن یک ملک، فقط کافیست نیاز خود را ثبت کنید.",
            id: 2,
        },
        {
            // imgSrc: "/icons/pelake-man-register-o.svg",
            imgSrc: localStorage.getItem("veeu-dark-mode") ? "/icons/dark-register-frame.svg" : "/icons/pelake-man-register-o.svg",
            title: " متقاضی اجاره (ویژه مستاجرین)",
            desc: "با پلاک مـن، اجاره ملک خود را در کوتاه‌ترین زمان ممکن انجام دهید.",
            id: 3,
        },
        {
            // imgSrc: "/icons/pelake-man-register-shakeHands.svg",
            imgSrc: localStorage.getItem("veeu-dark-mode") ? "/icons/dark-register-shake-hands.svg" : "/icons/pelake-man-register-shakeHands.svg",
            title: " تعاون و همکاری (ویژه مشاورین املاک) ",
            desc: "اینجا می‌توانید آگــهی‌ خـود را با همکارانتان به اشتراک بگذارید.",
            id: 4,
        },
    ];


    useEffect(() => {

        getAdsPrprtyCategory(adsPrptyTypeCode, adsPrptyTradeTypeCode)
        if (!(adsPrptyCategoryCode === 10 || adsPrptyCategoryCode === 11)) setAdsPrptyCategoryCode(getAdsPrprtyCategory(adsPrptyTypeCode, adsPrptyTradeTypeCode))

        // setAbilityToConvert(false)
    }, [adsPrptyTypeCode, adsPrptyTradeTypeCode])


    useEffect(() => {
        getAllProvinses(1)
        getAllCities(2)
        getAllNeighbourhood(3)
    }, [])


    console.log(adsPrptyCategoryCode, "adsPrptyCategoryCode in CreateFile");
    console.log(provinses, "provinses in CreateFile");
    const changeCategoryHandler = () => {
        setAdsPrptyTypeCode(null)
        setAdsPrptyTradeTypeCode(null)
        setAdsPrptyCategoryCode(null)
        setFormPageVisible(false)
        setChoosePropertyType(false)
        setslideTransaction(false);
        setslidecate(false);
        setslidecate(true)


    }
    const handleAddPhone = () => {
        const trimmed = inputPhone.trim();
        if (/^\d+$/.test(trimmed) && !phoneNumbers.includes(trimmed)) {
            setPhoneNumbers([...phoneNumbers, trimmed]);
            setInputPhone(""); // Clear input after adding
        }
    };
    const handleRemovePhone = (num) => {
        setPhoneNumbers(phoneNumbers.filter((phone) => phone !== num))
    };

    const handleKeyPress = (event) => {
        if ((event.key === 'Enter')) {
            // Programmatically trigger a click on the Collapse header
            handleAddPhone()
        }
    }


    const handleNeighbourhoodChange = (selectedItem) => {
        setPolygonForMap(
            typeof allCoordinates[selectedItem.id] != "undefined"
                ? allCoordinates[selectedItem.id]
                : []
        );
    };

    console.log(polygonForMap, " polygonForMap in CreateFile ");

    return (
        <div className=''>
            {/* <TitileAndArrowBack title="ثبت آگهی" /> */}

            <div className="flex relative sticky top-0 z-40  items-center justify-center w-full py-2 bg-white border-b ">

                <HelmetComponent title=" ثبت آگهی" description="ثبت آگهی" />
                <h1 className="w-full text-center ">ثبت آگهی</h1>
                <Link className="absolute right-4" onClick={goBack}>
                    <img src="/icons/arrow-right.svg" alt="icon-right" className="" />
                </Link>
            </div>

            <div className="relative w-full flex justify-center mx-auto   overflow-x-hidden overflow-y-hidden sm:overflow-y-scroll h-[700px]">

                {/* Select category */}
                <div
                    className={` z-10 flex justify-center w-full mx-auto sm:transition-all sm:duration-500 transform translate-x-[0%] dark:bg-[#181818] ${slidecate ? "!translate-x-[100%]" : ""
                        }`}
                >
                    <div className="lg:w-[100%] mx-auto  w-full     ">
                        <div className="px-5  grid lg:grid-cols-1 grid-cols-2  ">
                            {files.map((file, index) => (
                                <div
                                    key={index}
                                    onClick={() => {
                                        slideCateHandler(index);
                                        if ((index === 0) || (index === 3)) { }
                                        else if ((index === 1)) {
                                            // slidetransaction(index)
                                            setSelectedAdsMainCategoryCode(1)
                                            setnumberofTransaction(7)
                                            // setslideTransaction(true);
                                            setAdsPrptyCategoryCode(10)

                                            setChoosePropertyType(true)
                                        } else if ((index === 2)) {
                                            // slidetransaction(index)
                                            setSelectedAdsMainCategoryCode(1)
                                            setnumberofTransaction(8)
                                            // setslideTransaction(true);
                                            setAdsPrptyCategoryCode(11)
                                            setChoosePropertyType(true)
                                        }

                                    }}
                                    className="min-h-32 bg-gray-100 shadow-register-box my-5 rounded-lg md:transition-none transition-all duration-500  py-6 relative lg:mx-0 mx-9   hover:-translate-y-12  md: hover:translate-y-0 hover:shadow-registerHover">
                                    <div className="flex">
                                        <img src={file.imgSrc} className="mx-4" />
                                        <div>
                                            <div className="font-bold text-[#454545] dark:text-[#B9B9B9] mb-2">{file.title}</div>
                                            <div className="text-[#454545] dark:text-[#B9B9B9] text-[14px] font-medium mb-3">{file.desc}</div>
                                        </div>
                                    </div>

                                    <img src="/icons/free.svg" className="absolute left-1 bottom-2 mt-2" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>






                <div
                    className={`absolute top-0 left-0 w-full h-screen transition-transform duration-500 transform ${slidecate
                        ? choosePropertyType
                            ? "translate-x-full" // goes off screen when third comes in
                            : "translate-x-0"    // visible if third is not active
                        : "-translate-x-full"   // hidden before first slide
                        }`}
                >
                    <div className="md:w-[100%] mx-auto w-[400px] h-screen overflow-y-scroll">
                        <div className="h-svh overflow-y-auto ">
                            <div className="sticky top-0 py-2 bg-white border border-t-0 border-l-0 border-r-0 border-1">
                                <p className="font-bold">انتخاب نوع معامله</p>
                                نوع معامله ملک مورد نظر را انتخاب کنید
                            </div>
                            {transaction.map((category, index) => (
                                <div
                                    key={index}
                                    onClick={() => {
                                        slidetransaction(index);
                                        setAdsPrptyTradeTypeCode(index + 1)
                                    }}
                                    className="flex flex-row w-full p-1"
                                >
                                    <div
                                        className={`${index + 1 === numberofTransaction
                                            ? "bg-green-50 dark:bg-[#414141]  rounded rounded-t-l border-green-200 ease-in duration-100"
                                            : "bg-white dark:bg-[#414141] "
                                            } py-4 flex w-full border border-1 border-t-0 border-l-0 border-r-0 items-center justify-between px-1`}
                                    >
                                        <h1 className="font-bold">{category.title}</h1>
                                        <img src="/icons/arrowLeft.svg" alt="active-icon" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>




                {/* select Type Home */}
                <div

                    className={`absolute top-0 left-0 w-full h-full transition-transform duration-500 transform  ${choosePropertyType ? "translate-x-0" : "-translate-x-full"
                        }`}

                >
                    <div className="md:w-[100%] mx-auto w-[400px] h-screen overflow-y-scroll">
                        <div className=" mb-[130px]">
                            <div className="sticky top-0 py-2 bg-white border border-t-0 border-l-0 border-r-0 border-1">
                                <p className="font-bold">انتخاب نوع ملک</p>
                                نوع ملک مورد نظر را انتخاب کنید
                            </div>

                            <>
                                {home.map((category, index) => (
                                    <div key={index} className={`flex flex-row p-1 w-full`}>
                                        <div
                                            onClick={() => {
                                                slideregister(index);
                                                setAdsPrptyTypeCode(index + 1)
                                                setFormPageVisible(true)
                                            }}
                                            className={`${index + 1 === numberofhome
                                                ? "bg-green-50 dark:bg-[#414141]  rounded rounded-t-l border-green-200 ease-in duration-100"
                                                : "bg-white dark:bg-[#414141] "
                                                } py-4 flex w-full border border-1 border-t-0 border-l-0 border-r-0 items-center justify-between px-1`}
                                        >
                                            <h1 className="font-bold">{category.title}</h1>
                                            <img src="/icons/arrowLeft.svg" alt="active-icon" />
                                        </div>
                                    </div>
                                ))}
                            </>

                        </div>
                    </div>
                </div>





                {/* forth page */}
                <div

                    className={`absolute top-0 left-0 w-full h-full transition-transform duration-500 transform  ${formPageVisible ? "translate-x-0" : "-translate-x-full"
                        }`}

                >
                    <div className="w-full mx-auto  h-screen overflow-y-scroll">
                        <div className=" mb-[130px]">


                            < div className='bg-white '>
                                <div className='sticky top-0 py-3 bg-white border border-t-0 border-l-0 border-r-0 border-1 flex justify-between px-2 z-10'>
                                    <p className='text-[14px]'>آگهی ویژه مالکین &gt;&gt; {transaction[adsPrptyTradeTypeCode - 1]?.title} {home[adsPrptyTypeCode - 1]?.title}</p>
                                    <p className='dark:text-[#B9B9B9] underline  underline-offset-[2px] dark:decoration-[#B9B9B9]  text-[12px]  cursor-pointer' onClick={changeCategoryHandler}>تغییر دسته بندی</p>
                                </div>
                                <div className='my-3 px-2'>
                                    <p className='dark:text-[#B9B9B9] font-bold'>انتخاب عکس</p>
                                </div>

                                {/* <div className='flex min-h-[64px] items-center'>
                                    <img src='/icons/Frame.svg' alt='' />
                                    <input
                                        type="file"
                                        onChange={handleFileChange}
                                        className="absolute inset-0 z-20 opacity-0 cursor-pointer"
                                    />
                                    
                                </div> */}

                                <div className="flex gap-2  items-center flex-row-reverse w-full">
                                    {/* Upload Button */}
                                    {imageList.length < 7 && (
                                        <div className="relative w-[70px] h-[70px] flex items-center justify-center rounded-md ">
                                            {localStorage.getItem("veeu-dark-mode") === "false" ? <>

                                                <img src="/icons/black-add-photo.svg" alt="" />
                                                <input
                                                    type="file"
                                                    onChange={handleFileChange}
                                                    className="absolute inset-0 opacity-0 cursor-pointer z-10"
                                                />
                                            </> : <>
                                                <img src="/icons/Frame.svg" alt="" />
                                                <input
                                                    type="file"
                                                    onChange={handleFileChange}
                                                    className="absolute inset-0 opacity-0 cursor-pointer z-10"
                                                />
                                            </>}

                                        </div>
                                    )}

                                    {/* Uploaded Images/Videos */}
                                    {images.map((img, index) => (
                                        <div
                                            key={index}
                                            className="relative w-[70px] h-[70px] rounded overflow-x-auto"
                                        >
                                            {/* Media Preview */}
                                            {img.startsWith("data:video/") ? (
                                                <video src={img} className="w-full h-full object-cover" />
                                            ) : (
                                                <img
                                                    src={img}
                                                    className="w-full h-full object-cover cursor-pointer"
                                                    onClick={() => setSelectedMainImages([index])}
                                                    alt=""
                                                />
                                            )}

                                            {/* Delete Button */}
                                            <button
                                                className="absolute top-0 right-0 bg-red-600 p-1 rounded-bl"
                                                onClick={() => handleDelete(index)}
                                            >
                                                <img src="/icons/white-trash.svg" className="w-4 h-4" />
                                            </button>

                                            {/* Main Image Label */}
                                            {selectedMainImages[0] === index && (
                                                <div className="absolute bottom-0 left-0 right-0 bg-red-600 text-white text-sm text-center py-1 text-[12px]">
                                                    عکس اصلی
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>


                                <div className="createFile-inputs px-2">
                                    <div class="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                        <input
                                            value={fileTitle}
                                            type="text"
                                            className="w-full pr-[70px] dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "
                                            placeholder="حداکثر 50 کاراکتر"
                                            onChange={(e) => setFileTitle(e.target.value)}
                                        />
                                        <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                            <span className="text-red-500"> * </span>
                                            عنوان:

                                        </label>
                                    </div>
                                    {([10, 11].includes(adsPrptyCategoryCode)) && (

                                        <><p>متراژ :</p>
                                            <div className='grid grid-cols-2 sm:grid-cols-1 gap-2'>


                                                <div class="relative sm:w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                    <input
                                                        value={meterageFrom}
                                                        type="number"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        className="w-full text-left px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "

                                                        onChange={(e) => setMeterageFrom(e.target.value)}
                                                    />
                                                    <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">

                                                        از:

                                                    </label>
                                                </div>


                                                <div class="relative sm:w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                    <input
                                                        value={meterageTo}
                                                        type="number"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        className="w-full text-left px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "

                                                        onChange={(e) => setMeterageTo(e.target.value)}
                                                    />
                                                    <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">

                                                        تا:

                                                    </label>
                                                </div>

                                            </div>

                                            {adsPrptyCategoryCode === 10 &&
                                                <>
                                                    <p>قیمت کل :</p>
                                                    <div className="grid grid-cols-2 sm:grid-cols-1 gap-2">

                                                        <div>
                                                            <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                                <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                    تومان
                                                                </label>
                                                                <input
                                                                    value={FormatPrice(
                                                                        ConvertPersianToEnglish(totalPriceFrom)
                                                                    )}
                                                                    type="text"
                                                                    className="w-full pl-[60px] text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] mt-2 "
                                                                    pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value.replace(
                                                                            /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                            ""
                                                                        );
                                                                        setTotalPriceFrom(ConvertPersianToEnglish(newValue));
                                                                    }}
                                                                />
                                                                <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                    از:
                                                                </label>
                                                            </div>
                                                            {totalPriceFrom && (
                                                                <p className="px-3 text-[12px] text-green-600 mb-2">
                                                                    {Num2persian(totalPriceFrom)} تومان
                                                                </p>
                                                            )}
                                                        </div>

                                                        <div>
                                                            <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                                <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                    تومان
                                                                </label>
                                                                <input
                                                                    value={FormatPrice(
                                                                        ConvertPersianToEnglish(totalPriceTo)
                                                                    )}
                                                                    type="text"
                                                                    className="w-full pl-[60px] text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] mt-2 "
                                                                    pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value.replace(
                                                                            /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                            ""
                                                                        );
                                                                        setTotalPriceTo(ConvertPersianToEnglish(newValue));
                                                                    }}
                                                                />
                                                                <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                    تا:
                                                                </label>
                                                            </div>
                                                            {totalPriceTo && (
                                                                <p className="px-3 text-[12px] text-green-600 mb-2">
                                                                    {Num2persian(totalPriceTo)} تومان
                                                                </p>
                                                            )}
                                                        </div>


                                                    </div>
                                                </>
                                            }
                                            {adsPrptyCategoryCode === 11 &&
                                                <div>
                                                    <p> ودیعه :</p>
                                                    <div className="grid grid-cols-2 sm:grid-cols-1 gap-2">


                                                        <div>
                                                            <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                                <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                    تومان
                                                                </label>
                                                                <input
                                                                    value={FormatPrice(
                                                                        ConvertPersianToEnglish(depositeFrom)
                                                                    )}
                                                                    type="text"
                                                                    className="w-full pl-[60px] text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] mt-2 "
                                                                    pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value.replace(
                                                                            /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                            ""
                                                                        );
                                                                        setDepositeFrom(ConvertPersianToEnglish(newValue));
                                                                    }}
                                                                />
                                                                <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                    از:
                                                                </label>
                                                            </div>
                                                            {depositeFrom && (
                                                                <p className="px-3 text-[12px] text-green-600 mb-2">
                                                                    {Num2persian(depositeFrom)} تومان
                                                                </p>
                                                            )}
                                                        </div>
                                                        <div>
                                                            <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                                <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                    تومان
                                                                </label>
                                                                <input
                                                                    value={FormatPrice(
                                                                        ConvertPersianToEnglish(depositeTo)
                                                                    )}
                                                                    type="text"
                                                                    className="w-full pl-[60px] text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] mt-2 "
                                                                    pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value.replace(
                                                                            /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                            ""
                                                                        );
                                                                        setDepositeTo(ConvertPersianToEnglish(newValue));
                                                                    }}
                                                                />
                                                                <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                    تا:
                                                                </label>
                                                            </div>
                                                            {depositeTo && (
                                                                <p className="px-3 text-[12px] text-green-600 mb-2">
                                                                    {Num2persian(depositeTo)} تومان
                                                                </p>
                                                            )}

                                                        </div>



                                                    </div>
                                                    <div>
                                                        <p> اجاره :</p>
                                                        <div className="grid grid-cols-2 sm:grid-cols-1 gap-2">
                                                            <div className=''>
                                                                <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                                    <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                        تومان
                                                                    </label>
                                                                    <input
                                                                        value={FormatPrice(
                                                                            ConvertPersianToEnglish(rentFrom)
                                                                        )}
                                                                        type="text"
                                                                        className="w-full pl-[60px] text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] mt-2 "
                                                                        pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                                        onChange={(e) => {
                                                                            const newValue = e.target.value.replace(
                                                                                /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                                ""
                                                                            );
                                                                            setRentFrom(ConvertPersianToEnglish(newValue));
                                                                        }}
                                                                    />
                                                                    <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                        از:
                                                                    </label>
                                                                </div>
                                                                {rentFrom && (
                                                                    <p className="px-3 text-[12px] text-green-600 mb-2">
                                                                        {Num2persian(rentFrom)} تومان
                                                                    </p>
                                                                )}
                                                            </div>

                                                            <div>
                                                                <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                                    <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                        تومان
                                                                    </label>
                                                                    <input
                                                                        value={FormatPrice(
                                                                            ConvertPersianToEnglish(rentTo)
                                                                        )}
                                                                        type="text"
                                                                        className="w-full pl-[60px] text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] mt-2 "
                                                                        pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                                        onChange={(e) => {
                                                                            const newValue = e.target.value.replace(
                                                                                /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                                ""
                                                                            );
                                                                            setRentTo(ConvertPersianToEnglish(newValue));
                                                                        }}
                                                                    />
                                                                    <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                        از:
                                                                    </label>
                                                                </div>
                                                                {rentTo && (
                                                                    <p className="px-3 text-[12px] text-green-600 mb-2">
                                                                        {Num2persian(rentTo)} تومان
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>


                                            }



                                            <div>
                                                <p> عمر بنا :</p>
                                                <div className='grid grid-cols-2 sm:grid-cols-1 gap-2'>
                                                    <div class="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                        <input
                                                            value={lifeOftheBuildingFrom}
                                                            type="number"
                                                            inputMode="numeric"
                                                            pattern="[0-9]*"
                                                            className="w-full text-left px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "

                                                            onChange={(e) => setLifeOftheBuildingFrom(e.target.value)}
                                                        />
                                                        <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">

                                                            از:

                                                        </label>
                                                    </div>


                                                    <div class="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                        <input
                                                            value={lifeOftheBuildingTo}
                                                            type="number"
                                                            inputMode="numeric"
                                                            pattern="[0-9]*"
                                                            className="w-full text-left px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "

                                                            onChange={(e) => setLifeOftheBuildingTo(e.target.value)}
                                                        />
                                                        <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">

                                                            تا:

                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {([5, 12, 6, 7, 8].includes(adsPrptyCategoryCode)) &&
                                        (<>
                                            <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                <input
                                                    className="w-full text-left px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "
                                                    type="number"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    value={propertyLandMetarage}
                                                    onChange={(e) => setPropertyLandMetarage(e.target.value)}
                                                />
                                                <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                    <span className="text-red-500"> * </span>
                                                    متراژ زمین :

                                                </label>
                                            </div>
                                            <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                <input
                                                    className="w-full text-left px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "
                                                    type="number"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    value={propertyWidth}
                                                    onChange={(e) => setPropertyWidth(e.target.value)}
                                                />
                                                <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                    <span className="text-red-500"> * </span>
                                                    عرض ملک (بر) :

                                                </label>
                                            </div>

                                        </>
                                        )
                                    }
                                    {([5, 6, 7, 12].includes(adsPrptyCategoryCode)) &&
                                        (<>
                                            <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                <input
                                                    className="w-full text-left px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "
                                                    type="number"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    value={squareFootageEntireProperty}
                                                    onChange={(e) => setSquareFootageEntireProperty(e.target.value)}
                                                />
                                                <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                    <span className="text-red-500"> * </span>
                                                    متراژ زیر بنای کل:

                                                </label>
                                            </div>


                                        </>
                                        )
                                    }



                                    {/* {(adsPrptyCategoryCode !== 5 && adsPrptyCategoryCode !== 12 && adsPrptyCategoryCode !== 6 && adsPrptyCategoryCode !== 7 && adsPrptyCategoryCode !== 8 && adsPrptyCategoryCode !== 10 && adsPrptyCategoryCode !== 11) && */}
                                    {!([5, 12, 6, 7, 8, 10, 11].includes(adsPrptyCategoryCode)) &&
                                        (<div className="  grid grid-cols-2 gap-2 sm:grid-cols-1">
                                            <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                <input
                                                    className="w-full text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "
                                                    type="number"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    value={meterage}
                                                    onChange={(e) => setMeterage(e.target.value)}
                                                />
                                                <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                    <span className="text-red-500"> * </span>
                                                    متراژ:

                                                </label>
                                            </div>

                                            <div class="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                <input
                                                    type="number"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    className="w-full text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "
                                                    value={numberOfRooms}
                                                    onChange={(e) => setNumberOfRooms(e.target.value)}
                                                />
                                                <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">

                                                    تعداد اتاق :

                                                </label>
                                            </div>
                                        </div>
                                        )
                                    }

                                    {(adsPrptyCategoryCode !== 8 && adsPrptyCategoryCode !== 10 && adsPrptyCategoryCode !== 11) && (<>
                                        <div class="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                            <input
                                                type="number"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                className="w-full text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "
                                                value={lifeOfTheBuilding}
                                                onChange={(e) => setLifeOfTheBuilding(e.target.value)}
                                            />
                                            <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">

                                                <span className="text-red-500"> * </span>
                                                عمر بنا:


                                            </label>
                                        </div>
                                    </>)
                                    }

                                    {(adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 3 || adsPrptyCategoryCode === 5) && (<>

                                        <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex ">

                                            <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                تومان
                                            </label>
                                            <input
                                                value={FormatPrice(
                                                    ConvertPersianToEnglish(pricePerMeter)
                                                )}
                                                type="text"
                                                className="w-full pl-[60px] text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] mt-2 "
                                                pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                onChange={(e) => {
                                                    const newValue = e.target.value.replace(
                                                        /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                        ""
                                                    );
                                                    setpPricePerMeter(ConvertPersianToEnglish(newValue));
                                                }}


                                            />
                                            <label className="absolute  right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                قیمت متری:
                                            </label>


                                        </div>
                                        {pricePerMeter && (
                                            <p className="px-3 text-[12px] text-green-600 mb-2">
                                                {Num2persian(pricePerMeter)} تومان
                                            </p>
                                        )}
                                        {hasNotChanged && <div className='text-[#B9B9B9] text-[12px] mb-2'> در صورتی که قیمت را وارد نکنید، «توافقی» نمایش داده می‌شود.</div>}
                                        <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                            <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                تومان
                                            </label>
                                            <input
                                                value={FormatPrice(
                                                    ConvertPersianToEnglish(totalPrice)
                                                )}
                                                type="text"
                                                className="w-full pl-[60px] text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] mt-2 "
                                                pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                onChange={(e) => {
                                                    const newValue = e.target.value.replace(
                                                        /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                        ""
                                                    );
                                                    setTotalPrice(ConvertPersianToEnglish(newValue));
                                                }}
                                            />
                                            <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                قیمت کل:
                                            </label>
                                        </div>
                                        {totalPrice && (
                                            <p className="px-3 text-[12px] text-green-600 mb-2">
                                                {Num2persian(totalPrice)} تومان
                                            </p>
                                        )}
                                    </>)}

                                    {/* {(adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 4 || adsPrptyCategoryCode === 12 || adsPrptyCategoryCode === 7) && (<> */}
                                    {[2, 4, 12, 7].includes(adsPrptyCategoryCode) && (<>

                                        <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex ">

                                            <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                تومان
                                            </label>
                                            <input
                                                type="text"
                                                className="w-full text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] mt-2 "
                                                pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                value={FormatPrice(
                                                    ConvertPersianToEnglish(deposite)
                                                )}
                                                onChange={(e) => {
                                                    const newValue = e.target.value.replace(
                                                        /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                        ""
                                                    );
                                                    setDeposite(ConvertPersianToEnglish(newValue));
                                                }}
                                            />
                                            <label className="absolute pl-[60px] right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                ودیعه:
                                            </label>


                                        </div>
                                        {deposite && (
                                            <p className="px-3 text-[12px] text-green-600 mb-2">
                                                {Num2persian(deposite)} تومان
                                            </p>
                                        )}
                                        {!deposite && <div className='text-[#B9B9B9] text-[12px] mb-2'> در صورتی که قیمت را وارد نکنید، «توافقی» نمایش داده می‌شود.</div>}
                                        <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                            <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                تومان
                                            </label>
                                            <input
                                                type="text"
                                                className="w-full text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "
                                                pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                value={FormatPrice(
                                                    ConvertPersianToEnglish(rent)
                                                )}
                                                onChange={(e) => {
                                                    const newValue = e.target.value.replace(
                                                        /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                        ""
                                                    );
                                                    setRent(ConvertPersianToEnglish(newValue));
                                                }}
                                            />
                                            <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                اجاره:
                                            </label>
                                        </div>
                                        {rent && (
                                            <p className="px-3 text-[12px] text-green-600 mb-2">
                                                {Num2persian(rent)} تومان
                                            </p>
                                        )}
                                        <CustomCheckbox
                                            label="قابلیت تبدیل"
                                            checked={abilityToConvert}
                                            onChange={() => setAbilityToConvert(!abilityToConvert)}
                                        />

                                        {abilityToConvert &&
                                            <div className=''>

                                                <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex ">

                                                    <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                        تومان
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="w-full text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] mt-2 "
                                                        pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                        value={FormatPrice(
                                                            ConvertPersianToEnglish(convertingDeposite)
                                                        )}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value.replace(
                                                                /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                ""
                                                            );
                                                            setConvertingDeposite(ConvertPersianToEnglish(newValue));
                                                        }}
                                                    />
                                                    <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                        تبدیل مبلغ ودیعه:
                                                    </label>


                                                </div>
                                                {convertingDeposite && (
                                                    <p className="px-3 text-[12px] text-green-600 mb-2">
                                                        {Num2persian(convertingDeposite)} تومان
                                                    </p>
                                                )}
                                                <div className="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                    <label className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                        تومان
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="w-full text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "
                                                        pattern="[0-9۰-۹آ-ی‌ ‍٬]*"
                                                        value={FormatPrice(
                                                            ConvertPersianToEnglish(convertingRent)
                                                        )}
                                                        onChange={(e) => {
                                                            const newValue = e.target.value.replace(
                                                                /[^0-9۰-۹آ-ی‌ ‍٬]/g,
                                                                ""
                                                            );
                                                            setConvertingRent(ConvertPersianToEnglish(newValue));
                                                        }}
                                                    />
                                                    <label class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                        تبدیل مبلغ اجاره:
                                                    </label>
                                                </div>
                                                {!convertingRent && <div className='text-[#B9B9B9] text-[12px] mb-2'> در صورتی که قیمت را وارد نکنید، «توافقی» نمایش داده می‌شود.</div>}
                                                {convertingRent && (
                                                    <p className="px-3 text-[12px] text-green-600 mb-2">
                                                        {Num2persian(convertingRent)} تومان
                                                    </p>
                                                )}
                                            </div>}

                                    </>)}


                                    <div className='grid grid-cols-2 gap-2 md:grid-cols-1'>
                                        {(adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2) && (


                                            <div class="relative w-2/3 lg:w-full   dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex items-center justify-between">
                                                <div>طبقه</div>
                                                <input
                                                    value={floorFrom}
                                                    onChange={(e) => setFloorFrom(e.target.value)}
                                                    placeholder='طبقه‌ی چندم'
                                                    type="number"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    className="w-[132px] text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 px-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] placeholder:text-center my-2 "
                                                />
                                                <div>از</div>
                                                <input
                                                    value={floorTo}
                                                    onChange={(e) => setFloorTo(e.target.value)}
                                                    placeholder='تعداد کل طبقات'
                                                    type="number"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    className="w-[132px] text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 px-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-center placeholder:text-[12px] my-2 "
                                                />
                                            </div>



                                        )}


                                        {[1, 2, 5, 6, 7, 12].includes(adsPrptyCategoryCode) && (
                                            <div class="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex">
                                                <input
                                                    type="number"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    className="w-full text-left direction-ltr px-2 dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2 "
                                                    value={unitPerFloor}
                                                    onChange={(e) => setUnitPerFloor(e.target.value)}

                                                />
                                                <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                    تعداد واحد در طبقه:


                                                </label>
                                            </div>
                                        )}
                                    </div>

                                    {(adsPrptyCategoryCode !== 8) && (
                                        <div class="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex items-center justify-between my-2 text-black">
                                            <CustomCheckbox
                                                label="پارکینگ"
                                                checked={hasParking}
                                                onChange={() => setHasParking(!hasParking)}
                                            />
                                            <CustomCheckbox
                                                label="انباری"
                                                checked={hasBasement}
                                                onChange={() => setHasBasement(!hasBasement)}
                                            />
                                            <CustomCheckbox
                                                label="آسانسور"
                                                checked={hasElevator}
                                                onChange={() => setHasElevator(!hasElevator)}
                                            />
                                        </div>
                                    )}
                                    {selectedAdsMainCategoryCode === 8 && (
                                        <>
                                            <p className='dark:text-[#B9B9B9] mt-3'>شرایط تعاون</p>
                                            <div class="grid grid-cols-2 gap-2 w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9]  items-center justify-between mb-2">
                                                <CustomCheckbox
                                                    label="یک طرف - یک طرف"
                                                    checked={oneSided}
                                                    onChange={() => setOneSided(!oneSided)}
                                                />
                                                <CustomCheckbox
                                                    label="توافقی"
                                                    checked={mutualAgreement}
                                                    onChange={() => setMutualAgreement(!mutualAgreement)}
                                                />
                                                <CustomCheckbox
                                                    label="50 % - 50%"
                                                    checked={equalSplit}
                                                    onChange={() => setEqualSplit(!equalSplit)}
                                                />
                                                <CustomCheckbox
                                                    label="30% - 70%"
                                                    checked={notEqualSplit}
                                                    onChange={() => setNotEqualSplit(!notEqualSplit)}
                                                />
                                            </div>
                                        </>
                                    )}
                                    <div class="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] my-2">
                                        <label className=" pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                            توضیحات
                                        </label>

                                        <textarea
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            rows={4}
                                            type="text"
                                            className="w-full  dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] "
                                            placeholder='جهت کامل شدن اطلاعات آگهی و بازدید بیشتر آن اطلاعات تکمیلی را در این قسمت وارد بفرمایید .'
                                        />

                                    </div>


                                    <div
                                        className="first-collapsable relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex flex-col"

                                    >
                                        {/* Main Input */}
                                        <div className="w-full border rounded-md border-gray-300  mb-10">
                                            <div className='relative w-full flex' onClick={() => setIsChooseLocationSectionOpen(!isChooseLocationSectionOpen)}>
                                                <input
                                                    type="text"
                                                    className="w-full pr-[75px] dark:!bg-[#181818]   rounded-md  placeholder:text-[#B9B9B9] placeholder:text-[12px] my-1"
                                                />
                                                <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                    <span className="text-red-500"> * </span>
                                                    انتخاب موقعیت مکانی
                                                </label>
                                                <img
                                                    src="/icons/arrow-left-gray.svg"
                                                    alt=""
                                                    className={`absolute left-2 top-1/2 -translate-y-1/2 transition-transform duration-500 ${isChooseLocationSectionOpen ? "-rotate-90" : ""
                                                        }`}
                                                />

                                            </div>
                                            {/* Children Inputs */}


                                            <div
                                                className={`transition-all  flex justify-center duration-500 overflow-hidden ${isChooseLocationSectionOpen ? "max-h-[500px] opacity-100 px-2" : "max-h-0 opacity-0"
                                                    }`}
                                            >
                                                <div className="space-y-2 overflow-y-scroll">
                                                    {/* استان */}
                                                    <div className="">
                                                        <div className="relative w-full flex">
                                                            <input
                                                                onClick={() => setProvinceClicked(!provinceClicked)}
                                                                type="text"
                                                                className="w-full pr-[75px] dark:!bg-[#181818] py-1 border border-gray-300 rounded-md placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2"
                                                            />
                                                            <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                <span className="text-red-500">*</span>
                                                                {`استان / ${selectedProvince.locName}`}
                                                            </label>
                                                            <img
                                                                src="/icons/arrow-left-gray.svg"
                                                                alt=""
                                                                className={`absolute left-2 top-1/2 -translate-y-1/2 transition-transform duration-300 ${provinceClicked ? "-rotate-90" : ""
                                                                    }`}
                                                            />
                                                        </div>

                                                        {/* Animated Dropdown */}
                                                        <div
                                                            className={`transition-all duration-300 ease-in-out overflow-hidden ${provinceClicked && provinses?.length > 0
                                                                ? "max-h-[500px] opacity-100 mt-1"
                                                                : "max-h-0 opacity-0 mt-0"
                                                                }`}
                                                        >
                                                            <ul className="px-2 space-y-1 overflow-y-auto max-h-[200px] scrollbar-thin">
                                                                {provinses.map((province) => (
                                                                    <li
                                                                        key={province.id}
                                                                        className={`cursor-pointer py-1 px-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 ${selectedProvince?.id === province?.id
                                                                            ? "text-green-300 font-semibold bg-gray-50 dark:bg-gray-800"
                                                                            : ""
                                                                            }`}
                                                                        onClick={() => {
                                                                            setSelectedProvince(province)
                                                                            getAllCities(province.id)
                                                                            setProvinceClicked(false)
                                                                        }}
                                                                    >
                                                                        {province.locName}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    {/* شهر */}
                                                    <div className="">
                                                        <div className="relative w-full flex">
                                                            <input
                                                                onClick={() => setCityClicked(!cityClicked)}
                                                                type="text"
                                                                className="w-full pr-[75px] dark:!bg-[#181818] py-1 border border-gray-300 rounded-md placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2"
                                                            />
                                                            <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                <span className="text-red-500">*</span>
                                                                {`شهر / ${selectedCity.locName}`}
                                                            </label>
                                                            <img
                                                                src="/icons/arrow-left-gray.svg"
                                                                alt=""
                                                                className={`absolute left-2 top-1/2 -translate-y-1/2 transition-transform duration-300 ${cityClicked ? "-rotate-90" : ""
                                                                    }`}
                                                            />
                                                        </div>

                                                        {/* Animated Dropdown */}
                                                        <div
                                                            className={`transition-all duration-300 ease-in-out overflow-hidden ${cityClicked && provinses?.length > 0
                                                                ? "max-h-[500px] opacity-100 mt-1"
                                                                : "max-h-0 opacity-0 mt-0"
                                                                }`}
                                                        >
                                                            <ul className="px-2 space-y-1 overflow-y-auto max-h-[200px] scrollbar-thin">
                                                                {cities.map((city) => (
                                                                    <li
                                                                        key={city.id}
                                                                        className={`cursor-pointer py-1 px-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 ${selectedCity?.id === city?.id
                                                                            ? "text-green-300 font-semibold bg-gray-50 dark:bg-gray-800"
                                                                            : ""
                                                                            }`}
                                                                        onClick={() => {
                                                                            setSelectedcity(city)
                                                                            getAllNeighbourhood(city?.id)
                                                                            setCityClicked(false)
                                                                        }}
                                                                    >
                                                                        {city.locName}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    {/* محله */}
                                                    <div className="">
                                                        <div className="relative w-full flex">
                                                            <input
                                                                onClick={() => setDistrictClicked(!districtClicked)}
                                                                type="text"
                                                                className="w-full pr-[75px] dark:!bg-[#181818] py-1 border border-gray-300 rounded-md placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2"
                                                            />
                                                            <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                <span className="text-red-500">*</span>
                                                                {`محله / ${selectedDistrict.locName}`}
                                                            </label>
                                                            <img
                                                                src="/icons/arrow-left-gray.svg"
                                                                alt=""
                                                                className={`absolute left-2 top-1/2 -translate-y-1/2 transition-transform duration-300 ${districtClicked ? "-rotate-90" : ""
                                                                    }`}
                                                            />
                                                        </div>

                                                        {/* Animated Dropdown */}
                                                        <div
                                                            className={`transition-all duration-300 ease-in-out overflow-hidden ${districtClicked && provinses?.length > 0
                                                                ? "max-h-[500px] opacity-100 mt-1"
                                                                : "max-h-0 opacity-0 mt-0"
                                                                }`}
                                                        >
                                                            <ul className="px-2 space-y-1 overflow-y-auto max-h-[200px] scrollbar-thin">
                                                                {districtsLoader
                                                                    ?
                                                                    <div className='w-full flex justify-center'><Spin /> </div>
                                                                    :
                                                                    <> {neighbourhood.map((district) => (
                                                                        <li
                                                                            key={district.id}
                                                                            className={`cursor-pointer py-1 px-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 ${selectedDistrict?.id === district?.id
                                                                                ? "text-green-300 font-semibold bg-gray-50 dark:bg-gray-800"
                                                                                : ""
                                                                                }`}
                                                                            onClick={() => {
                                                                                setSelectedDistrict(district)
                                                                                handleNeighbourhoodChange(district);
                                                                                setDistrictClicked(false)
                                                                            }}
                                                                        >
                                                                            {district.locName}
                                                                        </li>
                                                                    ))}</>}

                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <div className="relative w-full flex">
                                                        <input
                                                            type="text"
                                                            className="w-full pr-[145px] dark:!bg-[#181818] py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2"
                                                            value={fulName}
                                                            onChange={(e) => setFulName(e.target.value)}
                                                        />
                                                        <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                            نام و نام خانوادگی :
                                                        </label>
                                                    </div>


                                                    <>
                                                        <div className="relative w-full flex">
                                                            <input
                                                                type="text"
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                                value={inputPhone}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    if (/^\d*$/.test(value)) {
                                                                        setInputPhone(value);
                                                                    }
                                                                }}
                                                                className="w-full text-left pl-7 dark:!bg-[#181818] py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2"
                                                                onKeyDown={handleKeyPress}
                                                            />
                                                            <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                                شماره تماس :
                                                            </label>
                                                            <img
                                                                src="/icons/dark-green-plus.svg"
                                                                alt="Add"
                                                                onClick={handleAddPhone}
                                                                className="absolute left-1 top-1/2 -translate-y-1/2 cursor-pointer"
                                                            />
                                                        </div>


                                                        <ul className="mt-2 space-y-1 text-sm dark:text-white">
                                                            {phoneNumbers.map((num, idx) => (
                                                                <li key={idx} className='w-full py-1 border border-gray-300 rounded-md flex items-center justify-end' >
                                                                    {num}
                                                                    <img src="/icons/minus-red.svg" alt='' onClick={() => handleRemovePhone(num)} />
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </>

                                                    <div class="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] my-2">
                                                        <label className=" pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                            آدرس
                                                        </label>

                                                        <textarea
                                                            value={fileAddress}
                                                            onChange={(e) => setFileAddress(e.target.value)}
                                                            rows={4}
                                                            type="text"
                                                            className="w-full text-[14px]  dark:!bg-[#181818]  py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] "
                                                            placeholder='آدرس را به صورت کامل وارد نمایید.'
                                                        />
                                                    </div>

                                                    <div class="relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] my-2">
                                                        <label className=" pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                            موقعیت مکانی روی نقشه
                                                        </label>

                                                        <CreateFileMap
                                                            polygon={polygonForMap}
                                                            selectedProvince={selectedProvince}
                                                            selectedCity={selectedCity}
                                                            // onMarkerChange={(position) => {
                                                            //     console.log("Marker moved to:", position);

                                                            //     setMarkerPosition([position?.lat, position?.lng])
                                                            // }} 
                                                            onMarkerChange={handleMarkerChange}

                                                        />
                                                    </div>



                                                </div>
                                            </div>
                                        </div>


                                    </div>





                                    {/* <div
                                        className="second-collapsable relative w-full dark:!bg-[#181818] dark:border-[1px]-[#B9B9B9] flex flex-col"
                                        onClick={() => setIsFacilitiesSectionOpen(!isFacilitiesSectionOpen)}
                                    >
                                       
                                        <div className="relative w-full flex">
                                            <input
                                                type="text"
                                                className="w-full pr-[75px] dark:!bg-[#181818] py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2"
                                            />
                                            <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                امکانات آگهی

                                            </label>
                                            <img
                                                src="/icons/arrow-left-gray.svg"
                                                alt=""
                                                className={`absolute left-2 top-1/2 -translate-y-1/2 transition-transform duration-500 ${isFacilitiesSectionOpen ? "-rotate-90" : ""
                                                    }`}
                                            />
                                        </div>

                                        


                                        <div
                                            className={`transition-all duration-500 overflow-hidden ${isFacilitiesSectionOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
                                                }`}
                                        >
                                            <div className="space-y-2">
                                               
                                                <div className="relative w-full flex">
                                                    <input
                                                        type="text"
                                                        className="w-full pr-[75px] dark:!bg-[#181818] py-1 border border-gray-300 rounded-md placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2"
                                                    />
                                                    <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                        <span className="text-red-500"> * </span>
                                                        استان / تهران
                                                    </label>
                                                </div>
                                               
                                                <div className="relative w-full flex">
                                                    <input
                                                        type="text"
                                                        className="w-full pr-[75px] dark:!bg-[#181818] py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2"
                                                    />
                                                    <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                        <span className="text-red-500"> * </span>
                                                        شهر / منطقه
                                                    </label>
                                                </div>

                                                
                                                <div className="relative w-full flex">
                                                    <input
                                                        type="text"
                                                        className="w-full pr-[75px] dark:!bg-[#181818] py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-white placeholder:text-[#B9B9B9] placeholder:text-[12px] my-2"
                                                    />
                                                    <label className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none px-1 text-[#B9B9B9] text-sm">
                                                        محله / اختیاری
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                    </div> */}
                                </div>

                            </div >

                        </div>
                    </div>
                </div>

            </div>
            {
                formPageVisible &&
                <div className="h-[60px] shadow-[0_-4px_4px_-1px_#FFFFFF80] flex items-center justify-center  dark:bg-[#181818] mt-6">
                    <button className='dark:bg-[#414141] dark:text-[#A6E8A5] w-[140px] px-4 py-1 rounded-lg bg-[#F3F3F3] text-[#028E32]' onClick={() => handleSubmit()}>ثبت آگهی</button>
                </div>
            }

        </div >
    )
}

export default CreateFile